import axios, { AxiosError } from "axios";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { ProviderSitesAllowedLanguagesApiService } from "./services/provider-sites-allowed-languages/provider-sites-allowed-languages-api.service";

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
export const LANGUAGES = ["en", "es", "fr", "it", "ar", "ca"];
let languageSelectedPreviously = false;
// the local resources are added as bundle, while the translations is loaded from server
// thus we achieve the result when the translations from server override local bundle
const host = window.location.hostname;
async function addBundle(lang: string) {
  const apiUrl = `${import.meta.env.VITE_API_URL}/locales/${lang}/${host}`;
  try {
    const result = await axios.get(apiUrl);
    if (result && result.data) {
      i18n.addResourceBundle(lang, "translation", result.data, true, true);
    }
  } catch (err) {
    const error = err as AxiosError;
    const errorMessage = error?.response?.data?.error ? error?.response?.data?.error : error?.message ?? error;

    console.error("Failure getting translation resource. ", errorMessage);
  }
}

//This is needed to know if there is a previously selected language
//It is added at this level since the init function will i18nextLng localStorage item anyway so we will not be able to know if its the language added by default or its the language used previously by the user
//If no selected language => in the callback function the language will be changed to the site/provider default one
if (localStorage.getItem("i18nextLng")) {
  languageSelectedPreviously = true;
}

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(HttpBackend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: LANGUAGES,
    lng: localStorage.getItem("i18nextLng") ?? "en",
    supportedLngs: LANGUAGES,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    lowerCaseLng: true,
    initImmediate: true,
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      partialBundledLanguages: true,
      crossDomain: true,
      addPath: `${import.meta.env.VITE_API_URL}/locales/add/{{lng}}.json`, // path to post missing resources
    },
    load: "languageOnly",
    saveMissing: true, // will post to backend about missing resources
  })
  .then(async () => {
    const result = await new ProviderSitesAllowedLanguagesApiService().loadItems();

    if (!result.error) {
      const allowedLanguages = result.items[0]?.allowedLanguages?.map((lang: any) => lang?.code);
      const defaultSiteOrProviderLanguage = result.items[0]?.defaultLanguage?.code;
      localStorage.setItem("languagesList", JSON.stringify(allowedLanguages));

      if (!localStorage.getItem("defaultSiteLanguage")) {
        localStorage.setItem(
          "defaultSiteLanguage",
          JSON.stringify({
            defaultLanguageCode: defaultSiteOrProviderLanguage,
            firstLoading: true,
          })
        );
      }

      if (!languageSelectedPreviously) {
        i18n.changeLanguage(defaultSiteOrProviderLanguage);
      }
    }
    LANGUAGES.forEach(async (language) => {
      await addBundle(language);
    });
  });

export default i18n;
